"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesAsText = datesAsText;
exports.formatMonthYear = formatMonthYear;
exports.scheduleDescriptionOverflowCheck = scheduleDescriptionOverflowCheck;
exports.toMonthDateTime = toMonthDateTime;
exports.toggleDescription = toggleDescription;
exports.updateDescriptionOverflow = updateDescriptionOverflow;
let descriptionResizeBound = false;
function toDateValue(date) {
  if (!date) return '';
  if (typeof date === 'string') return date;
  return date.value || '';
}

/* Function below generated by AI Model: GPT-5.3-Codex */
/* Prompt: the description needs to only show 2 lines and then more button
   please generate code for this. */
function updateDescriptionOverflow(root = document) {
  const selectorGroups = [{
    wrap: '.cvDescriptionWrap',
    text: '.cvDescriptionText',
    toggle: '.cvDescriptionToggle'
  }, {
    wrap: '.bioDescriptionWrap',
    text: '.bioDescriptionText',
    toggle: '.bioDescriptionToggle'
  }];
  selectorGroups.forEach(({
    wrap,
    text,
    toggle
  }) => {
    const wraps = root.querySelectorAll(wrap);
    wraps.forEach(container => {
      const textEl = container.querySelector(text);
      const button = container.querySelector(toggle);
      if (!textEl || !button) return;
      const isExpanded = textEl.classList.contains('isExpanded');
      if (isExpanded) {
        button.hidden = false;
        return;
      }
      const isOverflowing = textEl.scrollHeight > textEl.clientHeight + 1;
      button.hidden = !isOverflowing;
      if (!isOverflowing) {
        button.setAttribute('aria-expanded', 'false');
        button.textContent = '...more';
      }
    });
  });
}
function scheduleDescriptionOverflowCheck() {
  if (typeof window === 'undefined') return;
  window.requestAnimationFrame(() => updateDescriptionOverflow(window.document));
  if (!descriptionResizeBound) {
    window.addEventListener('resize', () => scheduleDescriptionOverflowCheck());
    descriptionResizeBound = true;
  }
}
function toggleDescription(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation?.();
  const button = event.currentTarget;
  if (!button) return;
  const descriptionId = button.getAttribute('aria-controls');
  if (!descriptionId) return;
  const textEl = document.getElementById(descriptionId);
  if (!textEl) return;
  const isExpanded = textEl.classList.toggle('isExpanded');
  button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  button.textContent = isExpanded ? '...less' : '...more';
  if (!isExpanded) {
    scheduleDescriptionOverflowCheck();
  }
}

/* Function below generated by AI Model: GPT-5.3-Codex */
/* Prompt: write me a function to convert a date to Month, Year */
function formatMonthYear(date) {
  const value = toDateValue(date);
  if (!value) return '';
  const year = value.slice(0, 4);
  const month = value.slice(5, 7);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = Number(month) - 1;
  if (!year || monthIndex < 0 || monthIndex > 11) return value;
  return `${monthNames[monthIndex]}, ${year}`;
}
function datesAsText(startDate, endDate) {
  const startValue = toDateValue(startDate);
  if (!startValue) return '';
  const start = formatMonthYear(startDate);
  const end = toDateValue(endDate) ? formatMonthYear(endDate) : 'Present';
  return `${start} to ${end}`;
}
function toMonthDateTime(date) {
  const value = toDateValue(date);
  if (!value) return undefined;
  return value.slice(0, 7);
}